import {useAuthenticatedUser} from "../user";

// TODO: DROP FUNCTION AND USE useAuthenticatedUser DIRECTLY
export const useAuth = () => {
  const user = useAuthenticatedUser();
  return {user};
};
